var DefaultNavBarFeatures = {
  hasNotifications: true,
  hasDesktopNotifications: false,
  hasSamples: true,
  hasPlugins: true,
  hasNetwork: true,
  hasChat: true,
  hasMastering: true,
  hasDistribution: true,
  hasCourses: true,
  hasPricing: true,
  hasSessions: true,
  hasSessionsPicker: true,
  hasProfile: true,
  hasReferral: true,
  hasRedeemPlugin: true,
  hasDesktopApp: true,
  hasMobileApp: true,
  hasSamplesInWebApp: false,
  hasCommunityChannels: true
};

export { DefaultNavBarFeatures };
